/* eslint-disable @next/next/no-img-element */
"use client";

import cx from "@/utils/cx";
import Image from "next/image";
import React from "react";

const Navbar = ({
  logoUrl,
  className,
  title,
}: {
  className?: string;
  logoUrl: string;
  title: string;
}) => {
  return (
    <header>
      <nav
        className={cx(
          "fixed top-0 w-full flex items-center bg-transparent p-4 pointer-events-none"
        )}
      >
        <img
          src={logoUrl}
          alt={title}
          className={cx("object-contain h-3 md:h-8 w-auto", className)}
        />
      </nav>
    </header>
  );
};

export default Navbar;
